import apiClient from "../lib/apiClient";

//============== Get Live Classes by UserId=============

// export const getLiveClasses = async (userId,schoolId) => {
//  return await apiClient.get(`/LiveClasses/GetLiveClasses?userId=${userId}&schoolId=${schoolId}`);
// };

export const getLiveClasses = async (userId, schoolId) => {
    const response = await apiClient.get(
        `/LiveClasses/GetLiveClasses?userId=${userId}&schoolId=${schoolId}`
    );

    return response.data;
};
